import axiosGlobalInstance from './configHttpInstance/http-instance';
import mockPropertyDetail from './fakes/property-detail';

const propertyDetail = (id) => {
  const useFake = !!Number(process.env.REACT_APP_MOCK_API);

  if(useFake) {
    return new Promise((resolve) => {
      setTimeout(() => resolve(mockPropertyDetail), 500);
    });
  }

  const httpInstance = axiosGlobalInstance();

  return httpInstance({
    method: 'GET',
    url: `/properties/${id}`,
  });
}

export default propertyDetail;

